import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"
import { getFontColorForBackgroundContrast } from "QuorumGrassroots/styled-components/helperFunctions"

export const LandingPageContainer = styleWithOrgDesign(styled.div`
    width: 100%;
    max-width: 50rem;
    margin: 2rem auto;
    padding: 0;

    @media (max-width: 768px) {
        margin: 1.5rem auto;
        padding: 0;
    }
`)

export const LandingPageHeader = styleWithOrgDesign(styled.h2`
    margin: 0 0 var(--plum-spacing-lg);
    text-align: center;
    font-size: var(--plum-font-md);
    font-weight: 400;
    color: #000000;
`)

export const ActionButtonsGrid = styleWithOrgDesign(styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    gap: var(--plum-spacing-md);

    @media (max-width: 768px) {
        gap: var(--plum-spacing-sm);
    }
`)

export const ActionButton = styleWithOrgDesign(styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1.5rem;
    gap: 1.125rem;
    border-radius: 0.75rem;
    border: 1.5px solid var(--plum-gray-4);
    background-color: var(--plum-white);
    box-shadow: var(--plum-shadow-md);
    cursor: pointer;
    color: var(--plum-black);
    font-weight: 500;
    line-height: normal;
    position: relative;
    transition:
        box-shadow 0.25s ease,
        color 0.25s ease,
        border-color 0.25s ease,
        background-color 0.25s ease;

    &:hover {
        box-shadow: var(--plum-shadow-lg);
        border-color: var(--primary-color-3, #7c94c6);
    }

    &:focus {
        outline: 2px solid var(--plum-gray-6);
        outline-offset: 2px;
        border-color: var(--plum-white);
    }

    /* Icon background animations copied from POC GOTV design */
    &.voter-btn:hover .graphAnimation {
        transform: rotate(180deg);
    }

    &.candidates-btn .candidates-icon {
        background-color: transparent;
    }

    &.candidates-btn:hover .graphAnimation {
        transform: rotate(105deg);
    }

    &.officials-btn:hover .officials-icon {
        box-shadow:
            0 0 0 2px #ffffff,
            0 0 0 4px var(--gotv-icon-primary),
            0 0 0 6px #ffffff;
        border-color: transparent;
    }

    &.calendar-btn .calendar-icon .graphAnimation {
        transform: scale(0.75) rotate(0deg);
    }

    &.calendar-btn .calendar-icon .graphAnimation svg {
        transition: transform 0.3s ease-out;
    }

    &.calendar-btn:hover .calendar-icon {
        background-color: transparent;
    }

    &.calendar-btn:hover .calendar-icon .graphAnimation svg:nth-child(1) {
        transform: scale(1) rotate(45deg);
    }

    &.calendar-btn:hover .calendar-icon .graphAnimation svg:nth-child(2) {
        transform: scale(1) rotate(-90deg);
    }

    @media (max-width: 768px) {
        padding: 1.5rem 1rem;
        min-height: 100px;
    }
`)

export const ButtonIcon = styleWithOrgDesign(styled.div`
    /* GOTV icons follow the organization's primary color so the module matches the campaign brand. */
    --gotv-icon-primary: var(--organization-primary-color-9);

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    margin-bottom: 0.75rem;
    border-radius: 1.5rem;
    background: var(--gotv-icon-primary);
    color: ${(props) => getFontColorForBackgroundContrast(props.organizationDesign?.primary_color || "#223d81")};

    i,
    i::before {
        font-size: 1.125rem;
        max-height: 1.125rem;
        z-index: 1;
        position: relative;
    }

    .graphAnimation {
        position: absolute;
        z-index: 0;
        top: -4px;
        left: -4px;
        width: calc(100% + 8px);
        height: calc(100% + 8px);
        color: var(--gotv-icon-primary);
        transform: rotate(0deg);
        transition: transform 0.3s ease-out;

        svg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: transform 0.3s ease-out;
        }

        svg path,
        svg rect {
            fill: currentColor;
        }
    }

    &.candidates-icon {
        background: transparent;
    }

    &.officials-icon {
        background: var(--gotv-icon-primary);
        border: 2px solid #ffffff;
        box-shadow: 0 0 0 2px var(--gotv-icon-primary);
        transition:
            box-shadow 0.25s ease,
            border-color 0.25s ease;
    }

    .user-check {
        position: absolute;
        right: 0.1rem;
        top: 0.4rem;
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 50%;
        background: var(--gotv-icon-primary);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
    }

    .user-check i {
        font-size: 0.6rem;
    }

    @media (max-width: 768px) {
        width: 2.25rem;
        height: 2.25rem;
        margin-bottom: 0.5rem;

        i,
        i::before {
            font-size: 1rem;
            max-height: 1rem;
        }
    }
`)

export const ButtonText = styleWithOrgDesign(styled.span`
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    text-align: center;
    line-height: 1.2;

    @media (max-width: 768px) {
        font-size: 0.9rem;
    }
`)
